// extracted by mini-css-extract-plugin
export var active = "_km-2";
export var recordingDot = "_km-1";
export var recordingIndicator = "_km-0";